import React from "react";
import { useParams } from "react-router-dom";

const SparePartsList = ({ spareParts }) => {
  const { lang } = useParams(); // get current language from URL

  const getLocalizedText = (field) => field?.[lang] || field?.en || "—";

  if (!spareParts || spareParts.length === 0) {
    return <p className="text-center text-gray-500">No spare parts available.</p>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {spareParts.map((part) => (
        <div key={part._id} className="border p-4 rounded-lg shadow-md bg-white">
          <img
            src={part.primaryImage}
            alt={getLocalizedText(part.name)}
            className="w-full h-48 object-cover rounded"
          />
          <h3 className="text-xl font-bold mt-2">{getLocalizedText(part.name)}</h3>
          <p className="text-gray-700 text-sm mt-1">{getLocalizedText(part.description)}</p>
          <p className="text-green-600 font-semibold mt-2">{part.price.toLocaleString()} CFA</p>
          {part.compatibility?.length > 0 && (
            <p className="text-sm text-gray-500 mt-1">
              Compatible with: {part.compatibility.join(", ")}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export default SparePartsList;
